import { render } from "./MfgAssemblyProcessShipmentArea.vue?vue&type=template&id=6b9a1fa5&scoped=true"
import script from "./MfgAssemblyProcessShipmentArea.vue?vue&type=script&lang=js"
export * from "./MfgAssemblyProcessShipmentArea.vue?vue&type=script&lang=js"

import "./MfgAssemblyProcessShipmentArea.vue?vue&type=style&index=0&id=6b9a1fa5&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9a1fa5"]])

export default __exports__